export const MAX_USERS = 2;
